module.exports = __webpack_public_path__ + "img/utenti-alertmsg.a4c85148.png";